import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { getRateLimitMessage } from '../utils/rateLimitUtils';
import './ApiRateLimitModal.css';

export const ApiRateLimitModal = ({ onRetry, isRetrying = false, attempCount = 0 }) => {
  const [secondsLeft, setSecondsLeft] = useState(45);
  const [rotatingMessage, setRotatingMessage] = useState(getRateLimitMessage());
  const progressPercentage = ((45 - secondsLeft) / 45) * 100;

  useEffect(() => {
    if (secondsLeft <= 0) {
      // Auto-retry
      onRetry();
      setSecondsLeft(45);
      return;
    }

    const timer = setTimeout(() => {
      setSecondsLeft(secondsLeft - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [secondsLeft, onRetry]);

  useEffect(() => {
    const messageInterval = setInterval(() => {
      setRotatingMessage(getRateLimitMessage());
    }, 10000);

    return () => clearInterval(messageInterval);
  }, []);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${String(secs).padStart(2, '0')}`;
  };

  const handleTryNow = () => {
    onRetry();
  };

  return (
    <motion.div
      className="api-rate-limit-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="api-rate-limit-modal"
        initial={{ scale: 0.9, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.9, opacity: 0 }}
      >
        <div className="api-rate-limit-content">
          <h2 className="api-rate-limit-title">Too Many People Getting Roasted 🔥</h2>
          
          <p className="api-rate-limit-message">
            The cosmic servers are overwhelmed.
            <br />
            <span className="roasted-count">[X,XXX]</span> people tried to get roasted
            <br />
            in the last minute — even the stars
            <br />
            need a breather. 😭
          </p>

          <div className="countdown-section">
            {isRetrying ? (
              <motion.div
                className="retrying-label"
                animate={{ opacity: [1, 0.5, 1] }}
                transition={{ duration: 1.5, repeat: Infinity }}
              >
                Retrying... ✨
              </motion.div>
            ) : (
              <>
                <p className="countdown-label">Auto-retrying in:</p>
                <div className="big-timer">{formatTime(secondsLeft)}</div>
                
                <div className="progress-bar-container">
                  <motion.div
                    className="progress-bar"
                    style={{ width: `${progressPercentage}%` }}
                    transition={{ duration: 0.3 }}
                  />
                </div>

                {attempCount > 0 && (
                  <p className="retry-attempt">Still busy, trying again...</p>
                )}

                <p className="rotating-message">{rotatingMessage}</p>

                <button className="try-now-btn" onClick={handleTryNow}>
                  Try now instead →
                </button>
              </>
            )}
          </div>
        </div>

        {/* Decorative stars */}
        <div className="api-modal-stars">
          {[...Array(15)].map((_, i) => (
            <div
              key={i}
              className="api-modal-star"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animation: `twinkle-api-modal ${2 + Math.random() * 3}s infinite`,
              }}
            />
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};
